





























import { Vue, Component } from "vue-property-decorator";
import Banner from "@/zh-website/src/components/website/Swiper/Banner.vue";
import SideBar from "@/zh-website/src/components/website/SideBar.vue";
import { HomeService } from "@/zh-website/src/views/Homes/service";
@Component({
  components: {
    Banner,
    SideBar
  }
})
export default class NewArrivalDetail extends Vue {
  navigationName = "" as any;
  solutionId = "";
  classifyName = "" as any;
  caseName = "" as any;
  classifyLink = "" as any;
  navigationLink = "" as any;
  result = "" as any;
  newArrival = {} as any;
  bannerData = {
    font4: "",
    font5: "",
    font3: "",
    button: "",
    style: {
      "background-image":
        'url("' + require("../../assets/case_banner.jpg") + '")',
      height: "320px"
    }
  };
  

  mounted() {
    this.getNewArrivalDetail();
  }
  getNewArrivalDetail() {
    HomeService.getNewArrivalDetail({ id: this.$route.params.id }).then(
      (res: any) => {
        this.newArrival = res.data;
        this.bannerData.font4 = this.newArrival.newArrivalCategory == '1' ? '新课有料' : '智赋人才';
      }
    );
  }
}
